import fs from "fs";
const res = [];
fs.readdir("./", (err, files) => {
    if (err) {
        throw err;
    }

    // files object contains all files names
    // log them on console
    files.forEach(file => {
        res.push(file);
    });
    const res2 = [];
    res.forEach(s => {
        const newName = s
            .replace(".svg", "")
            .split("-")
            .map((s, i) => {
                if (i === 0) {
                    return s;
                }
                return s.charAt(0).toUpperCase() + s.slice(1);
            })
            .join("");

        const n = `
    export { ${
        newName.charAt(0).toUpperCase() + newName.slice(1)
    } } from "./${s}/${s}";\n
export type {  ${
            newName.charAt(0).toUpperCase() + newName.slice(1)
        }Props } from "./${s}/${s}";`;
        // console.log(n, newName);
        res2.push(n);
    });
    console.log(res2);

    fs.writeFileSync("indexout2.txt", res2.join("\n"));
});
